// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__TvLyg","dropdown":"Settings_dropdown__BfP8E","label":"Settings_label__6XRht"};